import { FC } from "react";
import { useFieldArray } from "react-hook-form";

import SinglePatientInsurance from "./singleInsurance";
import { PatientInsuranceProps } from "./types";
import { InsuranceAttributesProps } from "src/pages/addCase/types";



const AddCasePatientInsurances: FC<PatientInsuranceProps> = ({ control, getValues, setValue, watch }): JSX.Element => {
  const { append: appendPatientInsurance, remove: removePatientInsurance } = useFieldArray({ control, name: "insurances_attributes" });
  const patientInsurances = watch("insurances_attributes") || [];

  const addNewPatientInsurance = (): void => {
    const newInsurance = {
      insurance_name: "",
      policy: "",
      bin: "",
      group_number: "",
      insurance_number: "",
      member_id: "",
      pcn: "",
      relation_firstname: "",
      relation_lastname: "",
      relation_middlename: "",
      rx_group: "",
      insurance_priority: patientInsurances.length - 1,
      relation_to_patient: "self",
      global_insurance_id: null,
      is_primary_insurance: patientInsurances.length === 0,
    } as InsuranceAttributesProps;
    appendPatientInsurance(newInsurance);
  };

  return (
    <div className="card mb-3">
      <div className="card-header bg-success-subtle">
        <h4 className="text-black m-0">Patient Insurances</h4>
      </div>
      <div className="card-body">
        {patientInsurances && patientInsurances.map((_d, index) => (
          <SinglePatientInsurance
            key={index}
            index={index}
            control={control}
            watch={watch}
            getValues={getValues}
            setValue={setValue}
            removeInsurance={removePatientInsurance}
          />
        ))}
        <div className="text-end">
          <button type="button" className="btn btn-success" onClick={addNewPatientInsurance}>
            <i className="fas fa-plus"></i> Add Insurance
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCasePatientInsurances;
